import { render } from "./nanamota-small-thing.vue?vue&type=template&id=f21213d4&scoped=true"
import script from "./nanamota-small-thing.vue?vue&type=script&lang=js"
export * from "./nanamota-small-thing.vue?vue&type=script&lang=js"

import "./nanamota-small-thing.vue?vue&type=style&index=0&id=f21213d4&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f21213d4"]])

export default __exports__